export default "__VITE_ASSET__34dN6ZNo__"